import { render } from "./DescendantDAbovilleList.vue?vue&type=template&id=277b2358&scoped=true"
import script from "./DescendantDAbovilleList.vue?vue&type=script&lang=js"
export * from "./DescendantDAbovilleList.vue?vue&type=script&lang=js"

import "./DescendantDAbovilleList.vue?vue&type=style&index=0&id=277b2358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277b2358"]])

export default __exports__